import { readAllData, STORES } from "utility"

export async function getByIdOffline(store, id) {
  if (id == null) return null
  const NewId = String(id)

  const all = await readAllData(store)
  const item = all.find((it) => String(it.id ?? it._id) === NewId) || null

  // ✅ AJOUT MINIMAL : populate patient si nécessaire
  if (item && item.patientId && !item.patient) {
    const patients = await readAllData(STORES.PATIENTS)

    const patient =
      patients.find((p) => String(p.id) === String(item.patientId)) || null

    if (patient) {
      return {
        ...item,
        patient,
      }
    }
  }

  return item
}
